<div class="presets" role="group" aria-label="Filtri predefiniti">
    <button *ngFor="let preset of presets; trackBy: trackById"
            type="button"
            class="preset"
            [ngClass]="'preset--' + preset.tone"
            [class.is-active]="preset.id === activeId"
            [attr.aria-pressed]="preset.id === activeId"
            [title]="preset.description || preset.label"
            (click)="select(preset.id)">
        <span class="preset-icon"><i class="fa" [ngClass]="preset.icon" aria-hidden="true"></i></span>
        <span class="preset-label">{{ preset.label }}</span>
        <span *ngIf="counts[preset.id] !== undefined" class="preset-count">{{ counts[preset.id] }}</span>
    </button>
</div>
